import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';
import { RequestStatusService } from '../../shared/services/request-status/request-status.service';
import { isGraphQLRequestBody } from '@shared/helpers/graphql-verifiers/graphql-body-checker';

export const RequestStatusInterceptor: HttpInterceptorFn = (req, next) => {
  const requestStatusService = inject(RequestStatusService);
  const operations = ['saveProjectSetup', 'createProject', 'createDepartment'];
  const isGraphQLRequest =
    isGraphQLRequestBody(req.body) &&
    operations.includes(req.body.operationName);

  if (isGraphQLRequest) {
    requestStatusService.incrementActiveRequests();
    return next(req).pipe(
      finalize(() => {
        requestStatusService.decrementActiveRequests();
      }),
    );
  } else {
    return next(req);
  }
};


